import { render, staticRenderFns } from "./loyout-aside-ad.vue?vue&type=template&id=19db34fd&scoped=true"
import script from "./loyout-aside-ad.vue?vue&type=script&lang=js"
export * from "./loyout-aside-ad.vue?vue&type=script&lang=js"
import style0 from "./loyout-aside-ad.vue?vue&type=style&index=0&id=19db34fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db34fd",
  null
  
)

export default component.exports